// extracted by mini-css-extract-plugin
module.exports = {"stickyDetector":"StickyDetector-module--sticky-detector--dDYvo"};